module.exports = __webpack_public_path__ + "static/img/son5_active.c67ee978.png";